import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import axios from "../../api/axios";           // ← instancia con interceptors
import logoADUTEM from "../../assets/img/logoadutem.png";
import membreteADUTEM from "../../assets/img/membrete_adutem.png"; // ← hoja membretada completa (logo + línea verde + marca de agua + pie)
import jsPDF from "jspdf";

// ───────────────────────────────────────────────
// Componente Perfil
// ───────────────────────────────────────────────
const Perfil = () => {
  const navigate = useNavigate();

  const [usuario, setUsuario] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  

  useEffect(() => {
    const fetchPerfil = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get("/perfil");

        if (response.data?.ok) {
          setUsuario(response.data.usuario || response.data.perfil || null);
        } else {
          setError(response.data?.message || "Respuesta inválida del servidor");
        }
      } catch (err) {
        console.error("Error al cargar perfil:", err);
        const mensaje =
          err.response?.data?.message ||
          err.response?.data?.msg ||
          err.message ||
          "No se pudo cargar la información del perfil";
        setError(mensaje);
      } finally {
        setLoading(false);
      }
    };

    fetchPerfil();
  }, []);



  if (loading) return <LoadingState />;
  if (error || !usuario) return <ErrorState message={error || "No se encontró información del perfil"} />;

  // ───────────────────────────────────────────────
  // Certificado en PDF usando la hoja membretada real de ADUTEM
  // (logo + línea verde arriba, marca de agua "El Pensador" y
  // datos de contacto al pie), igual al formato del Word original.
  // ───────────────────────────────────────────────
  const descargarCertificadoPDF = () => {
    if (!usuario) return;

    const doc = new jsPDF({ unit: "mm", format: "a4" }); // 210 x 297 mm

    const {
      nombres,
      apellidos,
      cedula,
    } = usuario;

    const nombreCompleto = `${nombres} ${apellidos}`;
    const fechaHoy = new Date().toISOString().split("T")[0]; // formato YYYY-MM-DD, igual al Word original

    // 1) Fondo: hoja membretada completa (logo ADUTEM, línea verde,
    //    marca de agua y pie de contacto) — reemplaza el rectángulo
    //    verde sólido que se usaba antes.
    doc.addImage(membreteADUTEM, "JPEG", 0, 0, 210, 297);

    // 2) Título
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.text("CERTIFICACIÓN", 105, 58, { align: "center" });

    // 3) Cuerpo del texto (mismo texto que el certificado físico original)
    doc.setFontSize(11);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0, 0, 0);

    const parrafo1 =
      `Ing. Alex Dueñas Rivadeneira PhD, Presidente de la Asociación de Docentes ` +
      `de la Universidad Técnica de Manabí-ADUTEM, Certifica: que ${nombreCompleto}, ` +
      `C.I. ${cedula}, es socio/a activo/a de esta Asociación.`;

    const lineas1 = doc.splitTextToSize(parrafo1, 160);
    doc.text(lineas1, 25, 78, { align: "justify", maxWidth: 160 });

    const yParrafo2 = 78 + lineas1.length * 6.5 + 10;
    const parrafo2 =
      "La interesada puede hacer del presente certificado el uso que estime conveniente.";
    doc.text(parrafo2, 25, yParrafo2);

    // 4) Fecha
    doc.text(`Portoviejo, ${fechaHoy}`, 115, 125);

    // 5) Firma
    doc.text("Ing. Alex Dueñas Rivadeneira PhD", 105, 158, { align: "center" });
    doc.text("Presidente - ADUTEM", 105, 165, { align: "center" });

    doc.save(`certificado_${cedula}.pdf`);
  };

  const {
    nombres,
    apellidos,
    cedula,
    email,
    telefono,
    estado,
    created_at,
  } = usuario;

  const nombreCompleto = `${nombres} ${apellidos}`.trim();
  const primeraLetra = nombres.charAt(0).toUpperCase() || "U";

  const fechaRegistro = new Date(created_at).toLocaleDateString("es-EC", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  return (
    <>
      <Navbar socioNombre={nombreCompleto} primeraLetra={primeraLetra} />

      <main className="container py-5">
        <header className="text-center mb-5">
          <h1 className="fw-bold" style={{ color: "#2c3e50" }}>
            Mi Perfil
          </h1>
          <p className="text-muted lead">Información personal registrada</p>
        </header>

        <div className="row justify-content-center">
          <div className="col-lg-8 col-xl-7">
            <div className="card border-0 shadow-lg" style={{ borderRadius: "16px", overflow: "hidden" }}>
              <div style={{ height: "8px", backgroundColor: "#2c5f2d" }} />

              <div className="card-body p-5">
                <div className="text-center mb-5">
                  <div
                    className="rounded-circle d-flex align-items-center justify-content-center mx-auto shadow"
                    style={{
                      width: "120px",
                      height: "120px",
                      backgroundColor: "#f1c40f",
                      color: "#2c3e50",
                      fontSize: "3.5rem",
                      fontWeight: "bold",
                    }}
                  >
                    {primeraLetra}
                  </div>
                  <h3 className="mt-3 fw-bold" style={{ color: "#2c3e50" }}>
                    {nombreCompleto}
                  </h3>
                  <span className="badge bg-success fs-6 px-4 py-2 mt-2">{estado}</span>
                </div>

                <div className="row g-4">
                  <InfoItem label="Nombres" value={nombres} />
                  <InfoItem label="Apellidos" value={apellidos} />
                  <InfoItem label="Cédula" value={cedula} />
                  <InfoItem label="Correo electrónico" value={email} />
                  <InfoItem label="Teléfono" value={telefono || "No registrado"} />
                  
                  <InfoItem label="Miembro desde" value={fechaRegistro} fullWidth />
                </div>

                

                

                
              </div>
            </div>
          </div>
        </div>
      </main>

    

     

    </>
  );
};

// ───────────────────────────────────────────────
// Navbar
// ───────────────────────────────────────────────
const Navbar = ({ socioNombre, primeraLetra }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    navigate("/login", { replace: true });
  };

  return (
    <nav
      className="navbar navbar-expand-lg navbar-dark shadow-sm"
      style={{
        background: "#FFD123",
        padding: "18px 0",
        position: "sticky",
        top: 0,
        zIndex: 1000
      }}
    >
      <div className="container-fluid px-4">

        <Link className="navbar-brand d-flex align-items-center" to="/DashboardSocio">
          <img
            src={logoADUTEM}
            alt="ADUTEM"
            style={{ height: "68px" }}
          />
        </Link>

        <button
          className="navbar-toggler border-0"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav mx-auto gap-1">
            {[
              { to: "/DashboardSocio", label: "Inicio", end: true },
              { to: "/vercuotas", label: "Mis Cuotas" },
              { to: "/reservasSocios", label: "Reservas" },
              { to: "/MisReservas", label: "Mis Reservas" },
            ].map(({ to, label, end = false }) => (
              <li className="nav-item" key={to}>
                <NavLink
                  to={to}
                  end={end}
                  className={({ isActive }) =>
                    `nav-link px-4 py-2 rounded-pill fw-medium ${
                      isActive
                        ? "active bg-white text-dark shadow-sm"
                        : "text-white"
                    }`
                  }
                  style={{ fontSize: "1.02rem" }}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* ✅ FIX: position-relative para que el menú se ancle al botón y no al viewport */}
          <div className="dropdown position-relative">
            <button
              className="btn btn-link text-decoration-none p-0 border-0 d-flex align-items-center gap-2"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <div
                className="rounded-circle d-flex align-items-center justify-content-center shadow"
                style={{
                  width: "42px",
                  height: "42px",
                  backgroundColor: "#f1c40f",
                  color: "#2c3e50",
                  fontWeight: "700",
                  fontSize: "1.25rem",
                  border: "2px solid rgba(255,255,255,0.6)"
                }}
              >
                {primeraLetra}
              </div>

              <div className="text-white text-start d-none d-md-block">
                <div className="fw-medium" style={{ fontSize: "1.02rem" }}>
                  {socioNombre}
                </div>
                <small className="opacity-75" style={{ fontSize: "0.82rem" }}>
                  Socio
                </small>
              </div>

              <i className="bi bi-chevron-down text-white ms-1"></i>
            </button>

            {/* ✅ FIX: dropdown-menu-md-end en vez de dropdown-menu-end
                - En móvil: se alinea a la izquierda del botón (no se sale de pantalla)
                - En desktop (≥768px): se alinea a la derecha como antes
                ✅ FIX: minWidth para evitar que el menú sea demasiado ancho en móvil */}
            <ul
              className="dropdown-menu dropdown-menu-md-end shadow-lg border-0 py-2"
              style={{ minWidth: "180px" }}
            >
              <li>
                <Link className="dropdown-item d-flex align-items-center py-2" to="/perfil">
                  <i className="bi bi-person-circle me-3 fs-5"></i>
                  Mi Perfil
                </Link>
              </li>

              <li><hr className="dropdown-divider my-1" /></li>

              <li>
                <button
                  className="dropdown-item d-flex align-items-center py-2 text-danger"
                  onClick={handleLogout}
                >
                  <i className="bi bi-box-arrow-right me-3 fs-5"></i>
                  Cerrar sesión
                </button>
              </li>
            </ul>
          </div>

        </div>
      </div>
    </nav>
  );
};

// ───────────────────────────────────────────────
// Subcomponentes
// ───────────────────────────────────────────────
const LoadingState = () => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center">
    <div className="text-center">
      <div className="spinner-border text-success" style={{ width: "3.5rem", height: "3.5rem" }} role="status">
        <span className="visually-hidden">Cargando...</span>
      </div>
      <p className="mt-4 text-muted fs-5">Cargando tu perfil...</p>
    </div>
  </div>
);

const ErrorState = ({ message }) => (
  <div className="min-vh-100 d-flex align-items-center justify-content-center p-3">
    <div className="alert alert-danger text-center shadow-lg p-4" role="alert" style={{ maxWidth: "500px" }}>
      <i className="bi bi-exclamation-triangle-fill me-3 fs-3"></i>
      <h4 className="alert-heading mb-3">Error</h4>
      <p className="mb-4">{message}</p>
      <button
        className="btn btn-outline-danger"
        onClick={() => window.location.reload()}
      >
        Intentar de nuevo
      </button>
    </div>
  </div>
);

const InfoItem = ({ label, value, fullWidth = false }) => (
  <div className={fullWidth ? "col-12" : "col-md-6"}>
    <strong className="d-block text-muted mb-1">{label}</strong>
    <p className="fs-5 mb-0 fw-medium">{value}</p>
  </div>
);

export default Perfil;